<template>
    <div id="container" style="height: 650px;">
        <v-container>
            <v-layout>
                <v-flex xs12 xl6 offset-xl3 pt-5 v-for="(card, i) in cards" :key="i" style="position:relative;">
                    <v-card class="elevation-4 offer-box"
                        :class="$vuetify.breakpoint.mdAndUp ? 'pl-4 pt-4 pr-4' : ''"
                    >
                        <div class="card-logo">
                        <v-img
                                :src="require('@/assets/EP-logo.png')"
                                aspect-ratio="2.75"
                                height="50px"
                                contain
                        ></v-img>
                        </div>
                        <hr style="color: lightgray">
                        <v-card-title primary-title>
                            <div>
                                <h2 class="font-weight-bold headline mb-4">{{card.title}}</h2>
                                <ul><li v-for="(check, i) in card.checks" :key="i">
                                    <v-icon color="green" style="margin-right: 4px;">fas fa-check</v-icon>
                                    <div class="check-text">{{check}}</div>
                                </li>
                                    <h3 class="pt-4 pb-2">Zusätzlich buchbare Optionen:</h3>
                                <li>
                                    <v-checkbox color="green" v-model="tvOption" hide-details class="smaller-checkbox">
                                        <template slot="label">
                                            TV Option<small class="ml-2">(+9,95€)</small>
                                        </template>
                                    </v-checkbox>
                                </li>
                                <li>
                                    <v-checkbox color="green" v-model="mobileOption" hide-details class="smaller-checkbox">
                                        <template slot="label">
                                            Handytarif Option<small class="ml-2">(3GB LTE, Telefon- und SMS-Flatrate, +9,99€)</small>
                                        </template>

                                    </v-checkbox>
                                </li>
                                </ul>
                            </div>
                        </v-card-title>
                        <div class="bottom-half" style="margin-bottom: 0;">
                        <div>
                                    <div class="price text-xs-right">
                                        <span v-if="$store.state.mobileOption && $store.state.tvOption" class="display-1">ab 39,93€*</span>
                                        <span v-else-if="$store.state.mobileOption" class="display-1">ab 29,98€*</span>
                                        <span v-else-if="$store.state.tvOption" class="display-1">ab 29,94€*</span>
                                        <span v-else class="display-1">ab 19,99€*</span>
                                    </div>

                            <v-card-actions class="actions">
                                <v-spacer></v-spacer>
                                <v-btn flat outline color="#226894" to="/kontakt">Bestellen</v-btn>
                            </v-card-actions>
                        </div>
                            <div class="price-explanation text-xs-center">
                                * je nach Tarif ändern sich die monatlichen Kosten, die Staffelpreise entnehmen Sie bitte Ihrer Auftragsbestätigung
                            </div>
                        </div>
                    </v-card>
                    <div class="popblase schnell elevation-8 hidden-xs-only">Schnelles Internet!</div>
                    <div class="popblase bester elevation-8 hidden-xs-only">Bester Preis!</div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  export default {
    data: () => ({
      cards: [
        { title: 'DSL ab 16.000 mbit/s',
          checks: [
            'Internet 16MBit/s',
            'Internet Flatrate',
            'Telefon Flatrate',
          ],
          price: '16.99',
        },
      ]
    }),
    computed: {
      tvOption: {
        get() {
          return this.$store.state.tvOption
        },
        set(val) {
          this.$store.dispatch('toggleTvOption', val)
        }
      },
      mobileOption: {
        get() {
          return this.$store.state.mobileOption
        },
        set(val) {
          this.$store.dispatch('toggleMobileOption', val)
        }
      }
    }
  }
</script>

<style lang="scss">
    #container {
        background: #f7f7f7;
    }

    .headline {
        font-size: 150%;
    }

    ul {
        list-style-type: none;
    }

    .price {
        color: red;
    }

    .check-text {
        display: inline-block;
        padding-left: 4px;
        font-size: 16px;
        color: rgba(0,0,0,0.74);
    }

    .smaller-checkbox {
        margin-top: 0;

        .v-input--selection-controls__ripple {
            margin-right: 0 !important;
        }
    }

    .fa-check-square:before {
        content: '\f00c' !important;
    }

    .accent--text,
    .theme--light.v-label {
        color: rgba(0,0,0,0.74);
    }

    .price-explanation {
        font-size: 10px;
    }

    .popblase {
        right: -60px;
        position: absolute;
        background-color: #dd271e;
        color: white;
        font-weight: bold;
        font-size: 150%;
        padding: 20px;
        transform: rotate(15deg);
        &.schnell {
            top: 150px;
        }
        &.bester {
            top: 250px;
        }
    }

    // phones
    @media (max-width: 767px) {

        .popblase {
            font-size: 80%;
            right: 0;
            padding: 5px;
            &.schnell {
                top: 150px;
            }
            &.bester {
                top: 200px;
            }
        }
    }


</style>
